import apiClient from '../apiClient';
import { POST_AREA_URL } from '../apiUrl';

const postAreaApi = data => {
  return apiClient.post(POST_AREA_URL, data);
};

export default postAreaApi;
